module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "SERIES1"
  }, [_vm._v("The Gospel and Our Culture Series")]), _vm._v(" "), _c('p', {
    staticClass: "SERIES2"
  }, [_vm._v("A series to foster the missional encounter of the gospel"), _c('br'), _vm._v("with North American culture")]), _vm._v(" "), _c('p', {
    staticClass: "SERIES3"
  }, [_vm._v("John R. Franke"), _c('br'), _c('span', {
    staticClass: "generaleditor _idGenCharOverride-1"
  }, [_vm._v("General Editor")]), _c('br'), _c('br'), _vm._v("•  •")]), _vm._v(" "), _c('p', {
    staticClass: "SERIES4"
  }, [_vm._v("  Volumes Published to Date  ")]), _vm._v(" "), _c('p', {
    staticClass: "SERIES5"
  }, [_vm._v("Lois Y. Barrett et al., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Treasure in Clay Jars: Patterns in Missional Faithfulness")])]), _vm._v(" "), _c('p', {
    staticClass: "SERIES5"
  }, [_vm._v("James V. Brownson, Inagrace T. Dietterich, Barry A. Harvey,"), _c('br'), _vm._v("and Charles C. West, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("StormFront: The Good News of God")])]), _vm._v(" "), _c('p', {
    staticClass: "SERIES5"
  }, [_vm._v("Michael J. Gorman, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Becoming the Gospel: Paul, Participation, and Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "SERIES5"
  }, [_vm._v("Darrell L. Guder, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Continuing Conversion of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "SERIES5"
  }, [_vm._v("Darrell L. Guder et al., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Missional Church: A Vision for the"), _c('br'), _vm._v("Sending of the Church in North America")])]), _vm._v(" "), _c('p', {
    staticClass: "SERIES5"
  }, [_vm._v("George R. Hunsberger, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bearing the Witness of the Spirit:"), _c('br'), _vm._v("Lesslie Newbigin’s Theology of Cultural Plurality")])]), _vm._v(" "), _c('p', {
    staticClass: "SERIES5"
  }, [_vm._v("George R. Hunsberger, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Story That Chooses Us:"), _c('br'), _vm._v("A Tapestry of Missional Vision")])]), _vm._v(" "), _c('p', {
    staticClass: "SERIES5"
  }, [_vm._v("George R. Hunsberger and Craig Van Gelder, editors, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Church between Gospel and Culture: The Emerging Mission in North America")])]), _vm._v(" "), _c('p', {
    staticClass: "SERIES5"
  }, [_vm._v("Craig Van Gelder, editor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Confident Witness — Changing World:"), _c('br'), _vm._v("Rediscovering the Gospel in North America")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b72fdeb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gorman_Becoming_the_Gospel_text_CC.vue
// module id = 57
// module chunks = 0